export default "__VITE_ASSET__DbAwGyha__"